module.exports = __webpack_public_path__ + "img/al.4b188ee0.svg";